import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { deDE, enUS, esES } from '@mui/x-date-pickers/locales';
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';

interface DynamicLocalizationProviderProps {
    children: React.ReactNode;
}

const DynamicLocalizationProvider: React.FC<DynamicLocalizationProviderProps> = ({ children }) => {
    const { i18n } = useTranslation();

    // Map i18n language codes to MUI locales
    const getLocaleConfig = (language: string) => {
        switch (language) {
            case 'de':
                return {
                    adapterLocale: 'de',
                    localeText: deDE.components.MuiLocalizationProvider?.defaultProps?.localeText
                };
            case 'es':
                return {
                    adapterLocale: 'es',
                    localeText: esES.components.MuiLocalizationProvider?.defaultProps?.localeText
                };
            case 'en':
            default:
                return {
                    adapterLocale: 'en',
                    localeText: enUS.components.MuiLocalizationProvider?.defaultProps?.localeText
                };
        }
    };

    const localeConfig = getLocaleConfig(i18n.language);

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={localeConfig.adapterLocale}
            localeText={localeConfig.localeText as any}
        >
            {children}
        </LocalizationProvider>
    );
};

export default DynamicLocalizationProvider;